// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"b26ac306","563":"aac70709","775":"c02ac8b2"}[chunkId] + ".chunk.css";
};